export class TaxNews {
  countryTaxNewsId?: number;
  countryId?: number;
  countryName?: string;
  name?: string;
  description?: string;
  date?: Date;
  isActive?: boolean;

  constructor(taxNewsResponse: TaxNews) {
    this.countryTaxNewsId = taxNewsResponse.countryTaxNewsId;
    this.countryId = taxNewsResponse.countryId;
    this.countryName = taxNewsResponse.countryName;
    this.name = taxNewsResponse.name;
    this.description = taxNewsResponse.description;
    this.date = taxNewsResponse.date;
    this.isActive = taxNewsResponse.isActive;
  }
}
